import { gql } from "@apollo/client";

export const TRIGGER_RISK_SCORE_DETERMINATION = gql`
  mutation triggerRiskScoreDetermination($clientIdentifier: String!) {
    invoice {
      triggerRiskScoreDetermination(clientIdentifier: $clientIdentifier) {
        success
      }
    }
  }
`;
